import fetch from "@/utils/request";


export default {
  getRechargeSubAccount(data?: object): any {
    return fetch({
      url: "/php/api/recharge/get_sub_account",
      method: "get",
      data
    });
  },

  applySubAccount(data?: object): any {
    return fetch({
      url: "/php/api/recharge/apply_sub_account",
      method: "post",
      data
    });
  },

  getRemittanceList(data?: object): any {
    return fetch({
      url: "/php/api/recharge/remittance_list",
      method: "get",
      data
    });
  },

  getRemittanceDetail(data?: object): any {
    return fetch({
      url: "/php/api/recharge/remittance_detail",
      method: "get",
      data
    });
  },

  submitTransferInto(data?: object): any {
    return fetch({
      url: "/php/api/recharge/submit_order",
      method: "post",
      data
    });
  },

  /**
   * 获得划转资金
   * @param data
   */
  getTransferFunds(data?: object): any {
    return fetch({
      url: "/php/api/transfer/user_money",
      method: "get",
      data,
      customLoading: true
    });
  },

  /**
   *提交资金划转账单
   */
  postTransferOrder(data?: object): any {
    return fetch({
      url: "/php/api/transfer/save",
      method: "post",
      data,
      loadingText: "正在划转"
    });
  }
};
